<div *ngIf="errors">
  <ul *ngFor="let error of errors">
    <li>{{ error }}</li>
  </ul>
</div>

<div *ngIf="error">
  <ul>
    <li>{{ error }}</li>
  </ul>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/form-error/form-error.component.html